import styled from '@emotion/styled'

export const MenuEditor = styled.div`
  --gm-ink: #182230;
  --gm-muted: #667085;
  --gm-border: #e4e7ec;
  --gm-soft: #f8fafc;
  --gm-blue: #3157d5;
  --gm-blue-soft: #eef3ff;
  --gm-teal: #087f6d;
  color: var(--gm-ink);

  .gm-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 24px;
    margin-bottom: 24px;
  }
  .gm-kicker {
    color: var(--gm-blue);
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.08em;
    margin-bottom: 7px;
    text-transform: uppercase;
  }
  h1 {
    color: var(--gm-ink);
    font-size: 28px;
    font-weight: 700;
    letter-spacing: -0.02em;
    line-height: 1.2;
    margin: 0;
  }
  .gm-subtitle {
    color: var(--gm-muted);
    font-size: 14px;
    line-height: 1.55;
    margin: 7px 0 0;
    max-width: 690px;
  }
  button:focus-visible,
  input:focus-visible {
    outline: 2px solid #7690e5;
    outline-offset: 2px;
  }
  .gm-primary,
  .gm-secondary,
  .gm-icon-button,
  .gm-add-button {
    align-items: center;
    border: 0;
    display: inline-flex;
    font-weight: 600;
    justify-content: center;
    transition: background-color 0.16s ease, color 0.16s ease, transform 0.16s ease;
  }
  .gm-primary {
    background: var(--gm-blue);
    border-radius: 8px;
    color: #fff;
    font-size: 13px;
    gap: 8px;
    min-height: 40px;
    padding: 0 16px;
    white-space: nowrap;
  }
  .gm-primary:hover:not(:disabled) {
    background: #2447bd;
    color: #fff;
    transform: translateY(-1px);
  }
  .gm-primary:disabled,
  .gm-icon-button:disabled {
    cursor: not-allowed;
    opacity: 0.42;
  }
  .gm-summary {
    display: grid;
    gap: 12px;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    margin-bottom: 16px;
  }
  .gm-stat {
    align-items: center;
    background: #fff;
    border: 1px solid var(--gm-border);
    border-radius: 10px;
    display: flex;
    gap: 12px;
    min-height: 76px;
    padding: 15px 16px;
  }
  .gm-stat-icon {
    align-items: center;
    background: var(--gm-blue-soft);
    border-radius: 8px;
    color: var(--gm-blue);
    display: flex;
    height: 38px;
    justify-content: center;
    width: 38px;
  }
  .gm-stat:nth-of-type(2) .gm-stat-icon {
    background: #edf9f6;
    color: var(--gm-teal);
  }
  .gm-stat:nth-of-type(3) .gm-stat-icon {
    background: #fff7e8;
    color: #a15c00;
  }
  .gm-stat-value {
    color: var(--gm-ink);
    font-size: 22px;
    font-weight: 700;
    line-height: 1;
  }
  .gm-stat-label {
    color: var(--gm-muted);
    font-size: 12px;
    margin-top: 5px;
  }
  .gm-workspace {
    background: #fff;
    border: 1px solid var(--gm-border);
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(16, 24, 40, 0.04);
    overflow: hidden;
  }
  .gm-toolbar {
    align-items: center;
    border-bottom: 1px solid var(--gm-border);
    display: flex;
    gap: 12px;
    justify-content: space-between;
    padding: 14px 16px;
  }
  .gm-search {
    max-width: 410px;
    position: relative;
    width: 100%;
  }
  .gm-search > svg {
    color: #98a2b3;
    left: 12px;
    pointer-events: none;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  .gm-search input {
    background: var(--gm-soft);
    border: 1px solid transparent;
    border-radius: 8px;
    color: var(--gm-ink);
    font-size: 13px;
    height: 40px;
    outline: none;
    padding: 0 38px;
    width: 100%;
  }
  .gm-search input:focus {
    background: #fff;
    border-color: #9db0ed;
    box-shadow: 0 0 0 3px rgba(49, 87, 213, 0.1);
  }
  .gm-search-clear {
    background: transparent;
    border: 0;
    color: #98a2b3;
    padding: 4px;
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
  }
  .gm-toolbar-actions {
    align-items: center;
    display: flex;
    gap: 6px;
  }
  .gm-secondary {
    background: #fff;
    border: 1px solid var(--gm-border);
    border-radius: 8px;
    color: #475467;
    font-size: 12px;
    gap: 7px;
    min-height: 36px;
    padding: 0 11px;
  }
  .gm-secondary:hover {
    background: var(--gm-soft);
    color: var(--gm-ink);
  }
  .gm-help,
  .gm-feedback {
    align-items: center;
    border-bottom: 1px solid;
    display: flex;
    font-size: 12px;
    gap: 8px;
    padding: 10px 16px;
  }
  .gm-help {
    background: #f8faff;
    border-color: #e7ecfb;
    color: #52627a;
  }
  .gm-help strong { color: #344054; }
  .gm-feedback--success { background: #ecfdf3; border-color: #abefc6; color: #067647; }
  .gm-feedback--error { background: #fef3f2; border-color: #fecdca; color: #b42318; }
  .gm-tree {
    background: #f7f8fa;
    min-height: 220px;
    padding: 14px;
  }
  .gm-category {
    background: #fff;
    border: 1px solid var(--gm-border);
    border-radius: 10px;
    margin-bottom: 10px;
    overflow: hidden;
  }
  .gm-category:last-child { margin-bottom: 0; }
  .gm-row {
    align-items: center;
    display: flex;
    gap: 10px;
    min-height: 58px;
    padding: 8px 10px;
    position: relative;
  }
  .gm-row--category { min-height: 64px; }
  .gm-row--product {
    background: #fbfcfd;
    border-top: 1px solid #eef0f3;
    margin-left: 34px;
    padding-left: 14px;
  }
  .gm-row--subproduct {
    border-top: 1px solid #f0f2f5;
    margin-left: 76px;
    min-height: 54px;
    padding-left: 14px;
  }
  .gm-row--subproduct::before {
    border-bottom: 1px solid #d9dee7;
    border-left: 1px solid #d9dee7;
    content: '';
    height: 27px;
    left: -22px;
    position: absolute;
    top: 0;
    width: 17px;
  }
  .gm-row--dragging { opacity: 0.42; }
  .gm-row--drop-target { box-shadow: inset 0 2px 0 var(--gm-blue); }
  .gm-drag,
  .gm-expand {
    align-items: center;
    background: transparent;
    border: 0;
    color: #98a2b3;
    display: flex;
    height: 32px;
    justify-content: center;
    padding: 0;
  }
  .gm-drag { cursor: grab; width: 24px; }
  .gm-drag:active { cursor: grabbing; }
  .gm-expand { color: #667085; width: 26px; }
  .gm-spacer { display: inline-block; width: 26px; }
  .gm-item-icon {
    align-items: center;
    border-radius: 8px;
    display: flex;
    flex: 0 0 auto;
    height: 36px;
    justify-content: center;
    width: 36px;
  }
  .gm-item-icon--category { background: var(--gm-blue-soft); color: var(--gm-blue); }
  .gm-item-icon--product { background: #edf9f6; color: var(--gm-teal); }
  .gm-item-icon--subproduct { background: #fff7e8; color: #a15c00; }
  .gm-item-copy { min-width: 0; }
  .gm-item-title {
    color: #263244;
    font-size: 13px;
    font-weight: 650;
    line-height: 1.35;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .gm-item-meta { color: #98a2b3; font-size: 11px; margin-top: 3px; }
  .gm-actions { align-items: center; display: flex; gap: 3px; margin-left: auto; }
  .gm-add-button {
    background: transparent;
    border-radius: 7px;
    color: var(--gm-blue);
    font-size: 12px;
    gap: 5px;
    min-height: 32px;
    padding: 0 9px;
  }
  .gm-add-button:hover { background: var(--gm-blue-soft); }
  .gm-icon-button {
    background: transparent;
    border-radius: 7px;
    color: #667085;
    height: 32px;
    width: 32px;
  }
  .gm-icon-button:hover:not(:disabled) { background: #eef1f5; color: #344054; }
  .gm-icon-button--danger:hover:not(:disabled) { background: #fef3f2; color: #d92d20; }
  .gm-empty,
  .gm-loading {
    align-items: center;
    color: var(--gm-muted);
    display: flex;
    flex-direction: column;
    font-size: 13px;
    gap: 10px;
    justify-content: center;
    min-height: 260px;
    text-align: center;
  }
  .gm-empty strong { color: var(--gm-ink); font-size: 15px; }
  .gm-empty p { margin: 0; max-width: 360px; }
  .gm-spinner { animation: gm-spin 0.8s linear infinite; }
  @keyframes gm-spin { to { transform: rotate(360deg); } }

  @media (max-width: 767px) {
    .gm-header, .gm-toolbar { align-items: stretch; flex-direction: column; }
    .gm-summary { grid-template-columns: 1fr; }
    .gm-search { max-width: none; }
    .gm-toolbar-actions { justify-content: space-between; }
    .gm-row--product { margin-left: 16px; }
    .gm-row--subproduct { margin-left: 38px; }
    .gm-actions .gm-add-button span, .gm-help { display: none; }
    .gm-actions { gap: 0; }
  }
`

export const MenuModalContent = styled.div`
  .gm-modal-header {
    align-items: flex-start;
    border-bottom: 1px solid #eaecf0;
    display: flex;
    justify-content: space-between;
    padding: 20px 22px 16px;
  }
  .gm-modal-eyebrow {
    color: #3157d5;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
    margin-bottom: 5px;
    text-transform: uppercase;
  }
  .gm-modal-title { color: #182230; font-size: 19px; font-weight: 700; margin: 0; }
  .gm-modal-subtitle { color: #667085; font-size: 12px; margin: 5px 0 0; }
  .gm-modal-close {
    align-items: center;
    background: transparent;
    border: 0;
    border-radius: 7px;
    color: #667085;
    display: flex;
    height: 32px;
    justify-content: center;
    width: 32px;
  }
  .gm-modal-close:hover { background: #f2f4f7; }
  .gm-modal-body { padding: 20px 22px 22px; }
  .gm-field-label {
    color: #344054;
    display: block;
    font-size: 12px;
    font-weight: 650;
    margin-bottom: 7px;
  }
  .gm-field-label--icon { margin-top: 20px; }
  .gm-field-hint { color: #98a2b3; font-size: 11px; font-weight: 400; margin-left: 5px; }
  .gm-name-input {
    border: 1px solid #d0d5dd;
    border-radius: 8px;
    color: #182230;
    font-size: 14px;
    height: 42px;
    outline: none;
    padding: 0 12px;
    width: 100%;
  }
  .gm-name-input:focus { border-color: #7690e5; box-shadow: 0 0 0 3px rgba(49, 87, 213, 0.1); }
  .gm-icon-grid { display: grid; gap: 8px; grid-template-columns: repeat(6, 1fr); }
  .gm-icon-option {
    align-items: center;
    background: #fff;
    border: 1px solid #e4e7ec;
    border-radius: 8px;
    color: #667085;
    display: flex;
    height: 48px;
    justify-content: center;
    position: relative;
  }
  .gm-icon-option:hover { background: #f8faff; border-color: #b8c5ec; color: #3157d5; }
  .gm-icon-option--selected { background: #eef3ff; border-color: #3157d5; color: #3157d5; }
  .gm-icon-check {
    background: #3157d5;
    border-radius: 50%;
    color: #fff;
    display: flex;
    padding: 2px;
    position: absolute;
    right: 3px;
    top: 3px;
  }
  .gm-modal-footer {
    align-items: center;
    border-top: 1px solid #eaecf0;
    display: flex;
    gap: 8px;
    justify-content: flex-end;
    padding: 14px 22px;
  }
  .gm-modal-button {
    align-items: center;
    border: 0;
    border-radius: 8px;
    display: inline-flex;
    font-size: 13px;
    font-weight: 650;
    gap: 7px;
    justify-content: center;
    min-height: 39px;
    padding: 0 15px;
  }
  .gm-modal-button--secondary { background: #fff; border: 1px solid #d0d5dd; color: #344054; }
  .gm-modal-button--primary { background: #3157d5; color: #fff; }
  .gm-modal-button--danger { background: #d92d20; color: #fff; }
  .gm-modal-button:disabled { cursor: not-allowed; opacity: 0.55; }
  .gm-delete-note {
    background: #fef3f2;
    border-left: 3px solid #f04438;
    color: #7a271a;
    font-size: 13px;
    line-height: 1.55;
    padding: 12px 14px;
  }
  .gm-delete-note strong { display: block; margin-bottom: 3px; }
  .gm-spinner { animation: gm-spin 0.8s linear infinite; }
  @keyframes gm-spin { to { transform: rotate(360deg); } }
  @media (max-width: 575px) { .gm-icon-grid { grid-template-columns: repeat(4, 1fr); } }
`
